import IntegrationMessageDetailPage from '../shared/IntegrationMessageDetailPage';

const OutboxMessageDetailPage = () => <IntegrationMessageDetailPage kind="outbox" />;

export default OutboxMessageDetailPage;
